export const NumberRenderer = ({value} = {}) => {
  if (! isNaN(value)) {
    return parseFloat(value).toFixed(1).toLocaleString()
  }
  return ''
}
